module.exports = __webpack_public_path__ + "static/media/success_icon.7d16756d.svg";